var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"text-field",class:{ saved: _vm.isSaved },attrs:{"label":_vm.label,"hide-details":"auto","solo":"","error":_vm.error,"error-messages":_vm.errorMessages},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }